import { restClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'

const q = (p: Record<string, unknown>) => new URLSearchParams(
  Object.entries(p).filter(([, v]) => v !== undefined && v !== null && v !== '').reduce((a, [k, v]) => ({ ...a, [k]: String(v) }), {})
).toString()

export const loyaltyService = {
  list: (p: { page?: number; limit?: number; search?: string } = {}) => {
    const params: Record<string, unknown> = { page: p.page??1, limit: p.limit??15, locale: 'en' }
    if (p.search) params.search = p.search
    return restClient.get(`${endpoints.loyaltyProgram.list}?${q(params)}`).then(r => r.data)
  },
  createUpdate: (d: Record<string, unknown>) => restClient.post(endpoints.loyaltyProgram.createUpdate, d).then(r => r.data),
  delete: (id: number) => restClient.delete(`${endpoints.loyaltyProgram.delete}/${id}`).then(r => r.data),
  eligibleTrainers: (p: { page?: number; limit?: number; trainer_reward_id?: string; status?: string } = {}) => {
    const params: Record<string, unknown> = { page: p.page??1, limit: p.limit??15 }
    if (p.trainer_reward_id) params.trainer_reward_id = p.trainer_reward_id
    if (p.status) params.status = p.status
    return restClient.get(`${endpoints.loyaltyProgram.eligibleTrainers}?${q(params)}`).then(r => r.data)
  },
  processReward: (d: Record<string, unknown>) => restClient.post(endpoints.loyaltyProgram.processReward, d).then(r => r.data),
}
